// Libs
import React from 'react'

// CSS
import './styles.scss'

const DashboardTitle = ({ title, subTitle }) => (
  <div className="dashboard-title">
    <p>{title}</p>
    <span>{subTitle}</span>
  </div>
)

export default DashboardTitle
